import { render, staticRenderFns } from "./ZddCertificateItem.vue?vue&type=template&id=f5f267b0&scoped=true"
import script from "./ZddCertificateItem.vue?vue&type=script&lang=js"
export * from "./ZddCertificateItem.vue?vue&type=script&lang=js"
import style0 from "./ZddCertificateItem.vue?vue&type=style&index=0&id=f5f267b0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f267b0",
  null
  
)

export default component.exports